import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { UserResponse } from "../model/response";

class UserApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);

    this.getUser = this.getUser.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.logoutUser = this.logoutUser.bind(this);
  }

  public getUser = () => this.get('/users') as Promise<AxiosResponse<UserResponse>>;

  public updateUser = (payload: any) => this.put("/users", payload);

  public logoutUser = async () => await this.get("/logout")
    .then((response: AxiosResponse) => response);

  public sendMessage = (
    ticket_description: string,
    user_ticket_category_id: string,
    files?: File[]
  ) => {
    const formData = new FormData();
    formData.append("ticket_description", ticket_description);
    formData.append("user_ticket_category_id", user_ticket_category_id);
    if (files) {
      files.forEach((file) => {
        formData.append("files[]", file);
      });
    }
    return this.post("/customer_support", formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }

  public ssnCheck = (SSN: string) => this.post("/ssn_check", { SSN });
}

export const userApi = new UserApi(apiConfig);
